import { render, staticRenderFns } from "./IconMenuHubs.vue?vue&type=template&id=68d254e3&"
import script from "./IconMenuHubs.vue?vue&type=script&lang=js&"
export * from "./IconMenuHubs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68d254e3')) {
      api.createRecord('68d254e3', component.options)
    } else {
      api.reload('68d254e3', component.options)
    }
    module.hot.accept("./IconMenuHubs.vue?vue&type=template&id=68d254e3&", function () {
      api.rerender('68d254e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconMenuHubs.vue"
export default component.exports